export const setMaxDateTime = (maxDate: Date) => ({
  type: 'SET_MAX_DATE_TIME',
  payload: maxDate,
});
